import React from 'react';
import { cn } from '@/lib/utils';
import './styles/badge.css';

const variantClasses = {
  default: 'badge-default',
  secondary: 'badge-secondary',
  success: 'badge-success',
  warning: 'badge-warning',
  error: 'badge-error',
  destructive: 'badge-error',
  info: 'badge-info',
  outline: 'badge-outline',
} as const;

interface BadgeProps {
  children: React.ReactNode;
  variant?: keyof typeof variantClasses;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({ children, variant = 'default', className }) => (
  <span className={cn(variantClasses[variant], className)}>{children}</span>
);
